<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Thumbs Up" class="d-icon d-icon--thumbs-up" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M5.553.776A.5.5 0 0 1 6.006.5a2.065 2.065 0 0 1 1.98 2.559L7.636 4.5h2.279a1.5 1.5 0 0 1 1.44 1.92l-1.165 4a1.5 1.5 0 0 1-1.44 1.08H2A1.5 1.5 0 0 1 .5 10V6A1.5 1.5 0 0 1 2 4.5h1.38a.5.5 0 0 0 .447-.277V4.22L5.554.776ZM3 5.5H2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1v-5Zm1 5h4.75a.5.5 0 0 0 .48-.36l1.165-4a.5.5 0 0 0-.48-.64H7a.5.5 0 0 1-.486-.618l.5-2.06V2.82a1.065 1.065 0 0 0-.728-1.275L4.723 4.668A1.503 1.503 0 0 1 4 5.366V10.5Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconThumbsUp',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
